// extracted by css-extract-rspack-plugin
export default {"value":"value-riFz7b"};